import React from 'react';
import { Section } from '../Section';
import { Button } from '../Button';
export var GetStarted = function () {
    var openReadMe = function () {
        return window.open('https://github.com/hhimanshu/create-react-ts-starter#readme');
    };
    return (React.createElement(Section, { title: 'Ready to get started?', bgColor: '#F9F8F8' },
        React.createElement(Button, { title: 'Follow README.md', onClick: openReadMe })));
};
